import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import { SlidersHorizontal, Columns3, Download, Settings, Plus, Info, HelpCircle,
    FolderInput, FolderOutput, TableOfContents
 } from "lucide-react";
import { Table, ConfigProvider, Tag, Button, Tooltip } from "antd";
import type { ColumnsType } from "antd/es/table";
import Layout from "../../Layout";
import { mixformatCurrency } from "services/mixin";
import { useNavigate } from 'react-router-dom';

interface LeaveGroup {
    tong: number;
    suDung: number;
    hetHan: number;
    tonCuoi: number;
}

interface LeaveSenior extends LeaveGroup {
    hienTai: number;
}

interface EmployeeRow {
    key: string;
    stt: number;
    maNS: string;
    hoTen: string;
    phongBan: string;
    tongTon: number;
    tongPhep: LeaveGroup;
    phepUng: number;
    phepLuyKe: LeaveGroup;
    phepThamNien: LeaveSenior;
    phepNam: LeaveGroup;
}

const rawData: EmployeeRow[] = [
    { key: "1", stt: 1, maNS: "HSNS_2023_1068", hoTen: "Thanh Tâm", phongBan: "Ban Thư ký Tổng Giám Đốc", tongTon: 9, tongPhep: { tong: 8, suDung: 3, hetHan: 0, tonCuoi: 5 }, phepUng: 4, phepLuyKe: { tong: 2, suDung: 2, hetHan: 0, tonCuoi: 0 }, phepThamNien: { hienTai: 0, tong: 0, suDung: 0, hetHan: 0, tonCuoi: 0 }, phepNam: { tong: 6, suDung: 1, hetHan: 0, tonCuoi: 5 } },
    { key: "2", stt: 2, maNS: "NV91", hoTen: "Trương Thị Hằng", phongBan: "Phòng Điều dưỡng-KSNK", tongTon: 9, tongPhep: { tong: 9, suDung: 0, hetHan: 0, tonCuoi: 9 }, phepUng: 0, phepLuyKe: { tong: 0, suDung: 0, hetHan: 0, tonCuoi: 0 }, phepThamNien: { hienTai: 0, tong: 0, suDung: 0, hetHan: 0, tonCuoi: 0 }, phepNam: { tong: 9, suDung: 0, hetHan: 0, tonCuoi: 9 } },
    { key: "3", stt: 3, maNS: "GN.49", hoTen: "Nguyễn Tấn Đạt TV", phongBan: "CẢI MÉP 2 - 128 teus", tongTon: 6, tongPhep: { tong: 14, suDung: 0, hetHan: 12, tonCuoi: 2 }, phepUng: 4, phepLuyKe: { tong: 12, suDung: 0, hetHan: 12, tonCuoi: 0 }, phepThamNien: { hienTai: 0, tong: 0, suDung: 0, hetHan: 0, tonCuoi: 0 }, phepNam: { tong: 2, suDung: 0, hetHan: 0, tonCuoi: 2 } },
    { key: "4", stt: 4, maNS: "4667", hoTen: "Giám đốc Indruino", phongBan: "[GTV] Chi nhánh HCM 1Office", tongTon: 4, tongPhep: { tong: 11, suDung: 0, hetHan: 11, tonCuoi: 0 }, phepUng: 4, phepLuyKe: { tong: 11, suDung: 0, hetHan: 11, tonCuoi: 0 }, phepThamNien: { hienTai: 0, tong: 0, suDung: 0, hetHan: 0, tonCuoi: 0 }, phepNam: { tong: 0, suDung: 0, hetHan: 0, tonCuoi: 0 } },
    { key: "5", stt: 5, maNS: "LQ112-0224", hoTen: "Lại Hà Phương HR", phongBan: "1Office - Hành chính nhân sự", tongTon: 4, tongPhep: { tong: 11, suDung: 0, hetHan: 11, tonCuoi: 0 }, phepUng: 4, phepLuyKe: { tong: 11, suDung: 0, hetHan: 11, tonCuoi: 0 }, phepThamNien: { hienTai: 0, tong: 0, suDung: 0, hetHan: 0, tonCuoi: 0 }, phepNam: { tong: 0, suDung: 0, hetHan: 0, tonCuoi: 0 } },
    { key: "6", stt: 6, maNS: "XD1.004", hoTen: "Trần Đức Bảo Hòa", phongBan: "Phòng Thiết kế sản phẩm", tongTon: 6, tongPhep: { tong: 13, suDung: 0, hetHan: 11, tonCuoi: 2 }, phepUng: 4, phepLuyKe: { tong: 11, suDung: 0, hetHan: 11, tonCuoi: 0 }, phepThamNien: { hienTai: 0, tong: 0, suDung: 0, hetHan: 0, tonCuoi: 0 }, phepNam: { tong: 2, suDung: 0, hetHan: 0, tonCuoi: 2 } },
    { key: "7", stt: 7, maNS: "00085", hoTen: "Nguyễn Quốc Trung", phongBan: "Ban cố vấn", tongTon: 7, tongPhep: { tong: 6, suDung: 0, hetHan: 3, tonCuoi: 3 }, phepUng: 4, phepLuyKe: { tong: 0, suDung: 0, hetHan: 0, tonCuoi: 0 }, phepThamNien: { hienTai: 6, tong: 0, suDung: 3, hetHan: 3, tonCuoi: 0 }, phepNam: { tong: 0, suDung: 0, hetHan: 0, tonCuoi: 0 } },
    { key: "8", stt: 8, maNS: "00366", hoTen: "Vũ Đình Thi", phongBan: "Phòng pháp chế", tongTon: 7, tongPhep: { tong: 6, suDung: 0, hetHan: 3, tonCuoi: 3 }, phepUng: 4, phepLuyKe: { tong: 0, suDung: 0, hetHan: 0, tonCuoi: 0 }, phepThamNien: { hienTai: 6, tong: 0, suDung: 3, hetHan: 3, tonCuoi: 0 }, phepNam: { tong: 0, suDung: 0, hetHan: 0, tonCuoi: 0 } },
    { key: "9", stt: 9, maNS: "HSNS_2024_1975", hoTen: "Lê Huỳnh Kim Khôi", phongBan: "Phòng Quản Lý Thiết Kế", tongTon: 4, tongPhep: { tong: 0, suDung: 0, hetHan: 0, tonCuoi: 0 }, phepUng: 4, phepLuyKe: { tong: 0, suDung: 0, hetHan: 0, tonCuoi: 0 }, phepThamNien: { hienTai: 0, tong: 0, suDung: 0, hetHan: 0, tonCuoi: 0 }, phepNam: { tong: 0, suDung: 0, hetHan: 0, tonCuoi: 0 } },
    { key: "10", stt: 10, maNS: "HSNS_2024_1083", hoTen: "Nguyễn Thị Thu Cúc", phongBan: "Phòng Tài Chính Kế Toán", tongTon: 4, tongPhep: { tong: 0, suDung: 0, hetHan: 0, tonCuoi: 0 }, phepUng: 4, phepLuyKe: { tong: 0, suDung: 0, hetHan: 0, tonCuoi: 0 }, phepThamNien: { hienTai: 0, tong: 0, suDung: 0, hetHan: 0, tonCuoi: 0 }, phepNam: { tong: 0, suDung: 0, hetHan: 0, tonCuoi: 0 } },
    { key: "11", stt: 11, maNS: "HSNS_2023_749", hoTen: "Phan Đức Tâm Tuấn", phongBan: "Phát triển sản phẩm", tongTon: 4, tongPhep: { tong: 0, suDung: 0, hetHan: 0, tonCuoi: 0 }, phepUng: 4, phepLuyKe: { tong: 0, suDung: 0, hetHan: 0, tonCuoi: 0 }, phepThamNien: { hienTai: 0, tong: 0, suDung: 0, hetHan: 0, tonCuoi: 0 }, phepNam: { tong: 0, suDung: 0, hetHan: 0, tonCuoi: 0 } },
    { key: "12", stt: 12, maNS: "NS_BDS_000005", hoTen: "Đỗ Đức Thắng", phongBan: "Team 2", tongTon: 4, tongPhep: { tong: 11, suDung: 0, hetHan: 11, tonCuoi: 0 }, phepUng: 4, phepLuyKe: { tong: 11, suDung: 0, hetHan: 11, tonCuoi: 0 }, phepThamNien: { hienTai: 0, tong: 0, suDung: 0, hetHan: 0, tonCuoi: 0 }, phepNam: { tong: 0, suDung: 0, hetHan: 0, tonCuoi: 0 } },
    { key: "13", stt: 13, maNS: "HHN4166", hoTen: "Đinh Thị Mỹ Hương", phongBan: "Tổ Sinh Học", tongTon: 4, tongPhep: { tong: 11, suDung: 0, hetHan: 11, tonCuoi: 0 }, phepUng: 4, phepLuyKe: { tong: 11, suDung: 0, hetHan: 11, tonCuoi: 0 }, phepThamNien: { hienTai: 0, tong: 0, suDung: 0, hetHan: 0, tonCuoi: 0 }, phepNam: { tong: 0, suDung: 0, hetHan: 0, tonCuoi: 0 } },
    { key: "14", stt: 14, maNS: "NS_BDS_000002", hoTen: "Nguyễn Hà Linh", phongBan: "Tổ Địa Lý", tongTon: 4, tongPhep: { tong: 11, suDung: 0, hetHan: 11, tonCuoi: 0 }, phepUng: 4, phepLuyKe: { tong: 11, suDung: 0, hetHan: 11, tonCuoi: 0 }, phepThamNien: { hienTai: 0, tong: 0, suDung: 0, hetHan: 0, tonCuoi: 0 }, phepNam: { tong: 0, suDung: 0, hetHan: 0, tonCuoi: 0 } },
    { key: "15", stt: 15, maNS: "XD1.017", hoTen: "Lê Hòa Bình", phongBan: "Phòng kế toán", tongTon: 4, tongPhep: { tong: 11, suDung: 0, hetHan: 11, tonCuoi: 0 }, phepUng: 4, phepLuyKe: { tong: 11, suDung: 0, hetHan: 11, tonCuoi: 0 }, phepThamNien: { hienTai: 0, tong: 0, suDung: 0, hetHan: 0, tonCuoi: 0 }, phepNam: { tong: 0, suDung: 0, hetHan: 0, tonCuoi: 0 } },
    { key: "16", stt: 16, maNS: "HHN4048", hoTen: "Lê Thị Hoàng Anh", phongBan: "Tổ Toán", tongTon: 4, tongPhep: { tong: 11, suDung: 0, hetHan: 11, tonCuoi: 0 }, phepUng: 4, phepLuyKe: { tong: 11, suDung: 0, hetHan: 11, tonCuoi: 0 }, phepThamNien: { hienTai: 0, tong: 0, suDung: 0, hetHan: 0, tonCuoi: 0 }, phepNam: { tong: 0, suDung: 0, hetHan: 0, tonCuoi: 0 } },
    { key: "17", stt: 17, maNS: "OSVE03", hoTen: "Kiều Mai Anh", phongBan: "Phòng Hành Chính Nhân Sự", tongTon: 4, tongPhep: { tong: 11, suDung: 0, hetHan: 11, tonCuoi: 0 }, phepUng: 4, phepLuyKe: { tong: 11, suDung: 0, hetHan: 11, tonCuoi: 0 }, phepThamNien: { hienTai: 0, tong: 0, suDung: 0, hetHan: 0, tonCuoi: 0 }, phepNam: { tong: 0, suDung: 0, hetHan: 0, tonCuoi: 0 } },
    { key: "18", stt: 18, maNS: "LQ64-0823", hoTen: "Dương Quốc Ân", phongBan: "Phòng kinh doanh 1 - HN", tongTon: 4, tongPhep: { tong: 11, suDung: 0, hetHan: 11, tonCuoi: 0 }, phepUng: 4, phepLuyKe: { tong: 11, suDung: 0, hetHan: 11, tonCuoi: 0 }, phepThamNien: { hienTai: 0, tong: 0, suDung: 0, hetHan: 0, tonCuoi: 0 }, phepNam: { tong: 0, suDung: 0, hetHan: 0, tonCuoi: 0 } },
    { key: "19", stt: 19, maNS: "1Office.011", hoTen: "Nguyễn Vũ Kỳ Duyên", phongBan: "Phòng kế toán", tongTon: 4, tongPhep: { tong: 11, suDung: 0, hetHan: 11, tonCuoi: 0 }, phepUng: 4, phepLuyKe: { tong: 11, suDung: 0, hetHan: 11, tonCuoi: 0 }, phepThamNien: { hienTai: 0, tong: 0, suDung: 0, hetHan: 0, tonCuoi: 0 }, phepNam: { tong: 0, suDung: 0, hetHan: 0, tonCuoi: 0 } },
    { key: "20", stt: 20, maNS: "00358", hoTen: "Nguyễn Hoàng Anh", phongBan: "Phòng kinh doanh 1 - HN", tongTon: 7, tongPhep: { tong: 6, suDung: 0, hetHan: 3, tonCuoi: 3 }, phepUng: 4, phepLuyKe: { tong: 0, suDung: 0, hetHan: 0, tonCuoi: 0 }, phepThamNien: { hienTai: 6, tong: 0, suDung: 3, hetHan: 3, tonCuoi: 0 }, phepNam: { tong: 0, suDung: 0, hetHan: 0, tonCuoi: 0 } },
];

// Ô số liệu có màu, theo đúng tinh thần bảng gốc: mỗi nhóm cột mang một sắc thái riêng
const Num: React.FC<{ value: number; tone?: "slate" | "blue" | "amber" | "fuchsia" | "emerald" }> = ({
    value,
    tone = "slate",
}) => {
    const tones: Record<string, string> = {
        slate: "text-slate-700 dark:text-slate-300",
        blue: "text-sky-600 dark:text-sky-400",
        amber: "text-amber-600 dark:text-amber-400",
        fuchsia: "text-fuchsia-600 dark:text-fuchsia-400",
        emerald: "text-emerald-600 dark:text-emerald-400",
    };
    return <span className={`tabular-nums font-medium ${tones[tone]}`}>{value}</span>;
};

const GroupHeader: React.FC<{ label: string; hint?: string }> = ({ label, hint }) => (
    <div className="flex items-center justify-center gap-1 text-[13px] font-semibold text-slate-600 dark:text-slate-300" style={{ textTransform: 'capitalize' }}>
        {label}
        {hint && (
            <Tooltip title={hint}>
                <HelpCircle size={12} className="text-[#3e91ab]" />
            </Tooltip>
        )}
    </div>
);

// const formatNumber = (value: number | null) => {
//     if (value === null) return "--";
//     return value.toLocaleString("vi-VN");
// };

export default function Furlough() {
    const { t } = useTranslation();
    const [showModalAdd, setShowModalAdd] = useState(false)
    const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
    const navigate = useNavigate();

    const columns: ColumnsType<EmployeeRow> = [
        {
            title: "STT",
            dataIndex: "stt",
            width: 56,
            fixed: "left",
            align: "center",
            render: (v) => <span>{v}</span>,
        },
        {
            title: "Mã NS",
            dataIndex: "maNS",
            width: 150,
            fixed: "left",
            align: "center",
            render: (v) => <span>{v}</span>,
        },
        {
            title: "Họ và tên",
            dataIndex: "hoTen",
            width: 180,
            fixed: "left",
            align: "center",
            render: (v) => <span>{v}</span>,
        },
        {
            title: "Phòng ban",
            dataIndex: "phongBan",
            width: 220,
            fixed: "left",
            align: "center",
            render: (v) => <span>{v}</span>,
        },
        {
            title: <GroupHeader label="Tổng tồn" hint="Tổng phép + Phép ứng" />,
            dataIndex: "tongTon",
            width: 100,
            align: "center",
            fixed: "left",
            //   sorter: (a, b) => a.tongTon - b.tongTon,
            render: (v) => (
                <span className="inline-flex min-w-[28px] justify-center px-2 py-0.5 text-emerald-600 dark:text-emerald-400 font-semibold">
                    {v}
                </span>
            ),
        },
        {
            title: <GroupHeader label="Tổng phép" hint="Phép lũy kế + Phép thâm niên + Phép năm"/>,
            align: "center",
            children: [
                { title: "Tổng", dataIndex: ["tongPhep", "tong"], width: 70, align: "center",className: "bg-[#fff7f6]", render: (v) => <Num value={v}/> },
                { title: "Sử dụng", dataIndex: ["tongPhep", "suDung"], width: 80, align: "center",className: "bg-[#fff7f6]", render: (v) => <Num value={v}  /> },
                { title: "Hết hạn", dataIndex: ["tongPhep", "hetHan"], width: 80, align: "center",className: "bg-[#fff7f6]", render: (v) => <Num value={v}  /> },
                { title: "Tồn cuối", dataIndex: ["tongPhep", "tonCuoi"], width: 80, align: "center",className: "bg-[#fff7f6]", render: (v) => <Num value={v} /> },
            ],
        },
        {
            title: <GroupHeader label="Phép ứng"/>,
            dataIndex: "phepUng",
            width: 90,
            align: "center",
            render: (v) => <Num value={v} />,
        },
        {
            title: <GroupHeader label="Phép lũy kế" hint="Phép lũy kế là ngày phép còn lại từ năm trước chuyển sang"/>,
            align: "center",
            children: [
                { title: "Tổng", dataIndex: ["phepLuyKe", "tong"], width: 70, align: "center",className: "bg-[#fafafa]", render: (v) => <Num value={v} tone="blue" /> },
                { title: "Sử dụng", dataIndex: ["phepLuyKe", "suDung"], width: 80, align: "center",className: "bg-[#fafafa]", render: (v) => <Num value={v} tone="blue" /> },
                { title: "Hết hạn", dataIndex: ["phepLuyKe", "hetHan"], width: 80, align: "center",className: "bg-[#fafafa]", render: (v) => <Num value={v} tone="blue" /> },
                { title: "Tồn cuối", dataIndex: ["phepLuyKe", "tonCuoi"], width: 80, align: "center",className: "bg-[#fafafa]", render: (v) => <Num value={v} tone="blue" /> },
            ],
        },
        {
            title: <GroupHeader label="Phép thâm niên" hint="Phép thâm niên bao gồm thâm niên hiện tại và thêm niên lũy kế"/>,
            align: "center",
            children: [
                { title: "Hiện tại", dataIndex: ["phepThamNien", "hienTai"], width: 80, align: "center", className: "bg-[#f7f5f4]", render: (v) => <Num value={v} tone="amber" /> },
                { title: "Sử dụng", dataIndex: ["phepThamNien", "suDung"], width: 80, align: "center", className: "bg-[#f7f5f4]", render: (v) => <Num value={v} tone="amber" /> },
                { title: "Hết hạn", dataIndex: ["phepThamNien", "hetHan"], width: 80, align: "center", className: "bg-[#f7f5f4]", render: (v) => <Num value={v} tone="amber" /> },
                { title: "Tồn cuối", dataIndex: ["phepThamNien", "tonCuoi"], width: 80, align: "center", className: "bg-[#f7f5f4]", render: (v) => <Num value={v} tone="amber" /> },
            ],
        },
        {
            title: <GroupHeader label="Phép năm" />,
            align: "center",
            children: [
                { title: "Tổng", dataIndex: ["phepNam", "tong"], width: 70, align: "center", className: "bg-[#fffbef]", render: (v) => <Num value={v} tone="fuchsia" /> },
                { title: "Sử dụng", dataIndex: ["phepNam", "suDung"], width: 80, align: "center", className: "bg-[#fffbef]", render: (v) => <Num value={v} tone="fuchsia" /> },
                { title: "Hết hạn", dataIndex: ["phepNam", "hetHan"], width: 80, align: "center", className: "bg-[#fffbef]", render: (v) => <Num value={v} tone="fuchsia" /> },
                { title: "Tồn cuối", dataIndex: ["phepNam", "tonCuoi"], width: 80, align: "center", className: "bg-[#fffbef]", render: (v) => <Num value={v} tone="fuchsia" /> },
            ],
        },
    ];

    return (
        <Layout>
            <Helmet>
                <title>{"Bảng phép"} | Khothi</title>
            </Helmet>

            {/* Header */}
            <div className="flex justify-between flex-wrap items-center mb-6 border-b border-gray-200 dark:border-gray-800 pb-2">
                <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100">
                    {"Bảng phép"}
                </h2>
                <Button
                    type="primary"
                    icon={<Plus size={14} />}
                    onClick={() => navigate('/furlough/add')}
                    className="bg-[#3e91ab] hover:!bg-[#357f96] border-[#3e91ab]"
                >
                    Thêm mới
                </Button>
            </div>

            {/* Toolbar */}
            <div className="flex flex-col sm:flex-row items-start sm:items-center justify-end gap-3 px-4 py-3 border-b border-gray-200 dark:border-gray-800 bg-gray-50/50 dark:bg-gray-900">
                {/* <div className="flex items-center gap-3 text-slate-500 dark:text-slate-400 text-xs">
                    <button className="hover:text-slate-800 dark:hover:text-slate-100 transition-colors">
                        <SlidersHorizontal className="w-4 h-4" />
                    </button>
                    <button className="hover:text-slate-800 dark:hover:text-slate-100 transition-colors">
                        <Columns3 className="w-4 h-4" />
                    </button>
                    {selectedRowKeys.length > 0 ? (
                        <span>
                            Đã chọn <b>{selectedRowKeys.length}</b> bản ghi
                        </span>
                    ) : (
                        <span>
                            Hiển thị 1 - {bankData.length} / {bankData.length} bản ghi
                        </span>
                    )}
                </div> */}

                <div className="flex items-center gap-4">
                    <button className="flex items-center gap-1.5 text-slate-500 hover:text-slate-800 dark:text-slate-400 dark:hover:text-slate-100 transition-colors text-xs">
                        <FolderInput className="w-4 h-4" />
                        <span>Import</span>
                    </button>
                    <button className="flex items-center gap-1.5 text-slate-500 hover:text-slate-800 dark:text-slate-400 dark:hover:text-slate-100 transition-colors text-xs">
                        <FolderOutput className="w-4 h-4" />
                        <span>Export</span>
                    </button>
                    <button className="flex items-center gap-1.5 text-slate-500 hover:text-slate-800 dark:text-slate-400 dark:hover:text-slate-100 transition-colors text-xs">
                        <TableOfContents className="w-4 h-4" />
                        <span>Chọn năm</span>
                    </button><button className="flex items-center gap-1.5 text-slate-500 hover:text-slate-800 dark:text-slate-400 dark:hover:text-slate-100 transition-colors text-xs">
                        <TableOfContents className="w-4 h-4" />
                        <span>Xem theo tháng</span>
                    </button>
                    <button className="flex items-center gap-1.5 text-slate-500 hover:text-slate-800 dark:text-slate-400 dark:hover:text-slate-100 transition-colors text-xs">
                        <Settings className="w-4 h-4" />
                        <span>Cài đặt</span>
                    </button>
                </div>
            </div>

            {/* Ant Design Table */}
            <div className="py-4">
                <ConfigProvider
                    theme={{
                        components: {
                            Table: {
                                headerBg: "#f8f9fa",
                                headerColor: "#6b7280",
                                cellPaddingBlock: 12,
                                rowHoverBg: "#eff6ff",
                            },
                        },
                    }}
                >
                    <div className="rounded-sm border border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-900 shadow-sm overflow-hidden">
                        <Table
                            columns={columns}
                            dataSource={rawData}
                            pagination={{ pageSize: 10, showSizeChanger: false }}
                            scroll={{ x: 1700 }}
                            size="middle"
                            bordered={false}
                            rowClassName={() =>
                                "hover:bg-slate-50 dark:hover:bg-slate-800/60 transition-colors"
                            }
                        />
                    </div>
                </ConfigProvider>
            </div>
        </Layout>
    );
}